import styled from '@emotion/styled';
import React from 'react';

interface IProps {
  title?: string;
  isHover?: boolean;
}

const ArrowLine = styled.span<{ isHover?: boolean }>`
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: ${(props) => props.theme.colors.primary};

  transition: transform 300ms ease-in-out;
  transform-origin: right center;
  transform: ${(props) => (props.isHover ? 'scaleX(1.5)' : 'scaleX(1)')};
`;

const Host = styled.a`
  position: relative;
  display: flex;
  align-items: center;

  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 85px;

  cursor: pointer;

  font-weight: 500;

  &:hover {
    ${ArrowLine} {
      transform: scaleX(1.5);
    }
  }
`;

const Text = styled.span``;

const Arrow = styled.span`
  position: absolute;
  right: 15px;

  display: flex;
  align-items: center;
`;

const ArrowOdd = styled.span`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3px 0 3px 6px;
  border-color: ${(props) =>
    `transparent transparent transparent ${props.theme.colors.primary}`};
`;

export const TextCardButton = ({ title, isHover, ...rest }: IProps) => {
  return (
    <Host {...rest}>
      <Text>{title}</Text>
      <Arrow>
        <ArrowLine isHover={isHover} />
        <ArrowOdd />
      </Arrow>
    </Host>
  );
};
